/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_Complete_Confirm_ActionInputs */

const en_task_reminders_complete_confirm_action = /** @type {(inputs: Task_Reminders_Complete_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete and cancel reminders`)
};

const pt_br2_task_reminders_complete_confirm_action = /** @type {(inputs: Task_Reminders_Complete_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir e cancelar lembretes`)
};

/**
* | output |
* | --- |
* | "Complete and cancel reminders" |
*
* @param {Task_Reminders_Complete_Confirm_ActionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_complete_confirm_action = /** @type {((inputs?: Task_Reminders_Complete_Confirm_ActionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_Complete_Confirm_ActionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_complete_confirm_action(inputs)
	return pt_br2_task_reminders_complete_confirm_action(inputs)
});